export default {
  'about.title': 'About',
  'about.titleHighlight': 'Me',
  'about.subtitle': 'Researcher bringing innovation to education and communication through technology',
  'about.passion.title': 'Research Passion',
  'about.passion.p1': 'I have a broad interest in technology domains such as XR, machine learning, and IoT, and I flexibly combine these technologies for research and development.',
  'about.passion.p2': 'I am committed to bringing innovation to education, communication, and gamification through technology. I actively pursue collaborative research and development with various people, regardless of university or industry boundaries.',
  'about.passion.p3': 'Currently, I am enrolled in the doctoral program at the University of Tokyo Graduate School while serving as CEO of Play Life Studio Inc., working on the social implementation of research outcomes.',
  'about.position.title': 'Current Positions',
  'about.position.utokyo': 'The University of Tokyo',
  'about.position.utokyoRole': 'Ph.D. Student, Interfaculty Information Studies',
  'about.position.utokyoLab': 'Yatani Laboratory (IIS-Lab)',
  'about.position.playlife': 'Play Life Studio Inc.',
  'about.position.playlifeRole': 'CEO & Representative Director',
  'about.position.nvidia': 'NVIDIA Corporation',
  'about.position.nvidiaRole': 'Senior Solution Architect',
  'about.interests.title': 'Research Interests',
  'about.interests.xr.title': 'XR Technology',
  'about.interests.xr.desc': 'Innovative experience design using extended reality technologies such as VR, AR, and MR',
  'about.interests.hci.title': 'HCI Research',
  'about.interests.hci.desc': 'Research and implementation of Human-Computer Interaction',
  'about.interests.edtech.title': 'EdTech',
  'about.interests.edtech.desc': 'Learning experiences that fuse educational technology and gamification',
  'about.interests.gamification.title': 'Gamification',
  'about.interests.gamification.desc': 'Enhancing engagement through game elements',
};
